/**
 * Created by ivo on 29.04.14.
 */
define([
    'jQuery'],
    function($) {
        /**
         * Visiblity Controll
         *
         * @param selector
         * @constructor
         */
        var ContentExpander = function (selector, options) {
            //Set elements
            this._elements = $(selector);

            //Set options
            var defaultOptions = {
                // The attribute for the target selector of the element
                'buttonSelectorAttribute': 'data-expand-button',

                // The class name that the content container has when content is expanded
                'expandedClass': 'is-expanded',

                // The class name of the content container when the content is cropped
                'expandableClass': 'is-expandable',

                // The class name of the content container when the content is cropped
                'notExpandableClass': 'is-notexpandable',

                // The class name that caller element has when target is visible
                'collapsedClass': 'is-collapsed',

                // Class name of button when container is expanded
                'buttonExpandedClass': 'is-targetexpanded',

                // Class name of target when visible
                'buttonCollapsedClass': 'is-targetcollapsed',

                // Animation duration in ms or jQuery animation speed keyword
                'animationDuration': 'fast',

                // If set to true, the labels will be exchanged
                'exchangeLabel': true,

                // Exchange label selector
                'exchangeLabelSelector': '[data-label-expanded]',

                // If set to true, buttons will be hidden if content height is smaller or equal container height
                'autoHideButton': true,

                // If set to true, window will scroll to top of container on collapse if whole window is not visible
                'scrollTopOnCollapse': true,

                // Offset in px to where the scroller window should scroll when it's collapsed
                // contentContainer.absoluteTop - scrollTopOnCollapseOffset = targetScrollPosition
                'scrollTopOnCollapseOffset': 100
            };
            this.addOptions(defaultOptions, options);

            this._initListeners();
        };

        ContentExpander.prototype = {
            /**
             * Initializes listeners
             * @returns {undefined}
             */
            _initListeners: function(){
                var self = this, isIE = Boolean(navigator.userAgent.match(/Trident/));
                this._elements.each(function(index, element){
                    // Get toggle buttons from the containers data-expand-button attribute and store container in
                    // button element
                    element = $(element);
                    var toggleButtons = $(element.attr(self.option('buttonSelectorAttribute')));
                    toggleButtons.data('expandableContainer', element.get(0));
                    toggleButtons.click($.proxy(self.toggleExpandedState, self));

                    // Hide content if expandability is unnecessary
                    if (self.option('autoHideButton')){
                        // Check if element is visible to get accurate scrollHeight
                        var scrollHeight = 0;
                        if (!element.is(':visible')){
                            // @TODO: Improve, if there is better way to get content height for invisible elements without cloning node
                            // Clone node and attach to body to get inner content height
                            var containerHeight = element.height();
                            var clonedElement = element.clone().css({
                                'position': 'fixed',
                                'top': - (containerHeight + 20000)
                            }).show().appendTo('body');

                            // Save scrollHeight and destroy node
                            scrollHeight = clonedElement[0].scrollHeight;
                            clonedElement.remove();
                        } else {
                            scrollHeight = element[0].scrollHeight;
                        }

                        // Hide buttons if content is smaller than container
                        if (scrollHeight <= element.outerHeight()){
                            toggleButtons.hide();

                            // Set class to expanded
                            element.removeClass(self.option('collapsedClass'));

                            // Container is not expandable
                            element.addClass(self.option('notExpandableClass'));
                        } else {
                            toggleButtons.show();
                            // Container is expandable
                            element.addClass(self.option('expandableClass'));
                        }
                    }
                });
            },

            /**
             * Toggle expanded state of target container
             * @param {type} element
             * @param {type} target
             * @returns {undefined}
             */
            toggleExpandedState: function(event){
                var target = $(event.currentTarget).data('expandableContainer');
                if (!target){
                    return;
                }

                if ($(target).hasClass(this.option('collapsedClass'))){
                    this.expandTarget(target);
                } else {
                    this.collapseTarget(target);
                }
            },

            /**
             * Expand container
             * @param {type} target
             * @returns {undefined}
             */
            expandTarget: function(target){
                var self = this;

                //Show target
                $(target).addClass(this.option('expandedClass'));
                $(target).removeClass(this.option('collapsedClass'));

                //Set classes on buttons
                var buttons = $($(target).attr(this.option('buttonSelectorAttribute')));
                buttons.addClass(this.option('buttonExpandedClass'));
                buttons.removeClass(this.option('buttonCollapsedClass'));

                //Change labels on caller element if enabled
                if (this.option('exchangeLabel')){
                    $(this.option('exchangeLabelSelector'), buttons).each(function(index, labelElement){
                        $(labelElement).text($(labelElement).attr('data-label-expanded'));
                    });
                }


            },

            /**
             * Collapse Container
             * @param {type} target
             * @returns {undefined}
             */
            collapseTarget: function(target){
                // Close
                $(target).removeClass(this.option('expandedClass'));
                $(target).addClass(this.option('collapsedClass'));

                var buttons = $($(target).attr(this.option('buttonSelectorAttribute')));
                buttons.removeClass(this.option('buttonExpandedClass'));
                buttons.addClass(this.option('buttonCollapsedClass'));

                //Change labels on caller element if enabled
                if (this.option('exchangeLabel')){
                    $(this.option('exchangeLabelSelector'), buttons).each(function(index, labelElement){
                        $(labelElement).text($(labelElement).attr('data-label-collapsed'));
                    });
                }

                //Scoll to top of content container
                if (this.option('scrollTopOnCollapse')){
                    if ($(window).scrollTop() > $(target).offset().top){
                        $("body, html").animate({
                            scrollTop: (Math.max($(target).offset().top - this.option('scrollTopOnCollapseOffset'), 0))
                        }, this.option('animationDuration'));
                    }
                }
            },



            /**
             * Internal variable to store configuration values
             */
            _options: {},

            /**
             * Adds options to the component.
             * The parameter options will overwrite the defaults
             * @param {object} defaults
             * @param {object|undefined} options
             * @returns {undefined}
             */
            addOptions: function(defaults, options){
                this._options = $.extend({}, this.getOptions(), defaults, options || {});
            },

            /**
             * Returns an object of all configuration options of the component
             * @returns {undefined|Object}
             */
            getOptions: function(){
                return this._options;
            },

            /**
             * Gets or sets option
             * @param name
             * @param value optional
             */
            option: function (name, value) {
                if (!_.isUndefined(value)) {
                    this._options[name] = value;
                }
                return this._options[name];
            }
        };

        return ContentExpander;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-visibilitycontrol/contentExpander.js
// module id = 411
// module chunks = 5 6